import { useEffect, useState, type JSX } from "react"
import { useAppSelector } from "../../app/hooks"
import { useNavigate, useParams } from "react-router-dom"
import { baseUrl } from "@/lib/utils"
import type { Result, UserResource } from "@/utils/types"
import { toast } from "sonner"
import { Skeleton } from "@/components/ui/skeleton"
import { ProfileHeader } from "./ProfileHeader"
import { HighscoreScrollable } from "./HighscoreScrollable"
import { ResultsChart } from "./ResultsChart"

export const User = (): JSX.Element | null => {
  const { id } = useParams()
  //   const homeSlice = useAppSelector(state => state.home)
  const authSlice = useAppSelector(state => state.auth)
  const navigate = useNavigate()

  const [user, setUser] = useState<UserResource | undefined>(undefined)
  const [results, setResults] = useState<Result[] | undefined>(undefined)
  const [highscores, setHighscores] = useState<Result[] | undefined>(undefined)

  function fetchUser() {
    const options: RequestInit = {
      method: "GET",
    }
    const userId = id ?? authSlice.user?.google_id
    if (!userId) {
      toast.error("Could not fetch user data")
      void navigate("/")
      return
    }

    fetch(`${baseUrl}/user/${userId}`, options)
      .then(res => res.json())
      .then(data => {
        const userData = data as UserResource
        console.log("userData:", userData)
        setUser(userData)
      })
      .catch((err: unknown) => {
        toast.error("Could not fetch user data")
        console.error("Fetch failed:", err)
      })
  }

  function fetchResults() {
    const userId = id ?? authSlice.user?.google_id
    if (!userId) return
    fetch(`${baseUrl}/result/user/${userId}`)
      .then(res => res.json())
      .then(data => {
        const resultsData = data as Result[]
        setResults(resultsData)
      })
      .catch((err: unknown) => {
        toast.error("Could not fetch user data")
        console.error("Fetch failed:", err)
      })
  }

  function fetchHighscores() {
    const userId = id ?? authSlice.user?.google_id
    if (!userId) return
    fetch(`${baseUrl}/highscore/${userId}`)
      .then(res => res.json())
      .then(data => {
        const highscoresData = data as Result[]
        // console.log("highscoresData:", highscoresData)
        setHighscores(highscoresData)
      })
      .catch((err: unknown) => {
        toast.error("Could not fetch user data")
        console.error("Fetch failed:", err)
      })
  }

  useEffect(() => {
    fetchUser()
    fetchResults()
    fetchHighscores()
  }, [])

  return (
    <div className="flex flex-col flex-1 justify-center max-w-4xl mx-auto gap-5">
      {user ? (
        <ProfileHeader user={user} results={results ?? []} highscores={highscores ?? []} />
      ) : (
        <Skeleton className="flex grow basis-4/12 rounded-xl" />
      )}
      {highscores ? (
        <HighscoreScrollable highscores={highscores} />
      ) : (
        <Skeleton className="flex grow basis-4/12 rounded-xl" />
      )}
      {results ? <ResultsChart results={results} /> : <Skeleton className="flex grow basis-4/12 rounded-xl" />}
    </div>
  )
}
